import { SuperAdminUsersPage } from "../../operator/console/super-admin-users";

export default function ConsoleSuperAdminUsers() {
  return <SuperAdminUsersPage />;
}
